var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.$style.message,
  _vm.$style[_vm.message.align],
  ("chat-window__message--" + (_vm.message.align))
]},[_c('div',{class:_vm.$style.meta},[_c('div',{class:_vm.$style.photoContainer},[_c('img',{attrs:{"src":_vm.message.user.photoUrl,"alt":""}})]),_vm._v(" "),(_vm.message.time)?_c('span',{class:_vm.$style.time},[_vm._v(_vm._s(_vm.message.time))]):_vm._e()]),_vm._v(" "),_c('div',{ref:"message",class:_vm.$style.msgContainer},[_vm._v(_vm._s(_vm.message.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cb9be0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/chat-window/message/message.vue
// module id = s9Em
// module chunks = 1